export default __webpack_public_path__ + "static/media/cosmic1.84ebae20.png";